<template>
  <div class="homePage">
    <!-- 顶部Header（保持一致） -->
    <div class="Header">
      <div class="h_left">
        <div class="title">
          <div>HQS</div>
          <div style="border-top: 1px solid #606266; padding-top: 2px">
            AUTOMOTIVE
          </div>
        </div>
      </div>
      <div class="h_right">
        <div class="htex">
          <div>{{ objuserinfo.user.account }}</div>
        </div>
        <img src="@/assets/quit.png" alt="" @click="outSys" />
      </div>
    </div>

    <!-- 主体内容区 -->
    <div class="home-page-body">
      <!-- 标题：Inspection Report 改为 Part -->
      <div class="btys">Part</div>

      <div style="height: calc(100% - 6vh); display: flex">
        <!-- 左侧区域：输入框+单列表+分页 -->
        <div class="leftmenu">
          <div style=" display: flex; align-items: flex-end; gap: 8px;">
            <el-form ref="partForm" :model="partForm" inline>
              <el-col :span="14">
                <el-form-item>
                  <el-input @input="partNumberInput" v-model="queryParams.partNumber" placeholder="Part No" clearable
                    size="small" style="width: 100%"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="10">
                <el-form-item>
                  <el-button type="primary" size="mini" @click="searchPartData()" style="width: 100%">Search</el-button>
                </el-form-item>
              </el-col>
            </el-form>
          </div>

          <!-- 左侧单列表（无标题，仅一列） -->
          <el-table :data="partData" size="small" style="width: 100%; margin-top: 1vw; flex-grow: 1"
            :show-header="false" class="customer-table" @row-click="handlePartRowClick">
            <el-table-column prop="code" label="" width="180">
            </el-table-column>
          </el-table>

          <!-- 左侧分页 -->
          <el-pagination class="fyys" small @size-change="handlePartSizeChange"
            @current-change="handlePartCurrentChange" :current-page.sync="partCurrentPage"
            :page-sizes="[10, 20, 30, 40]" :page-size="10" layout="prev, pager, next" :total="partTotal">
          </el-pagination>
        </div>

        <!-- 右侧区域 -->
        <div class="rightmenu">
          <!-- 右侧第一行：选中文字+Report按钮+筛选项 -->
          <div class="r_tbys">
            <div class="r_lys">
              <!-- 左侧列表选中的文字 -->
              <div class="ztyss" v-if="selectedPart">{{ selectedPart.code }}</div>
              <!-- Report按钮 -->
              <div class="delys" @click="handleReportClick()" style="cursor: pointer; margin-left: 16px">
                <i class="el-icon-edit" style="cursor: pointer"></i> Report
              </div>
            </div>

            <!-- 筛选项：Pallent No+Date+按钮 -->
            <div class="r_rys">
              <!-- Pallent No -->
              <div style="display: flex; align-items: center; margin-right: 12px">
                <span class="bdys">Pallet No</span>
                <el-input v-model="filterParams.palletNumber" placeholder="Pallet No" size="mini"
                  style="width: 120px; margin-left: 8px"></el-input>
              </div>

              <!-- Date时间段 -->
              <!-- 修改日期选择器部分 -->
              <div style="display: flex; align-items: center; margin-right: 22px;">
                <span class="bdys">Date</span>
                <el-date-picker v-model="filterParams.dateRange" type="daterange" range-separator="TO"
                  start-placeholder="start" end-placeholder="end" size="mini" style="margin-left: 18px; width: 440px;"
                  :clearable="false">
                </el-date-picker>
              </div>

              <!-- 按钮组 -->
              <div style="display: flex; gap: 8px">
                <el-button type="primary" size="mini" @click="handleRightSearch()">Search</el-button>
                <el-button size="mini" @click="handleRightClear()">Clear</el-button>
              </div>
            </div>
          </div>

          <!-- 右侧第二行：四列列表（无分页） -->
          <div style="margin: 1.5vh 0; width: 100%; box-sizing: border-box;">
            <el-table :data="summaryTableData" style="width: 100%;"
              :header-cell-style="{ background: '#FAFAFA', color: 'rgba(0, 0, 0, 0.65)' }">
              <el-table-column prop="sortNumber" label="Sort No" width="420"></el-table-column>
              <el-table-column prop="statusValue" label="Status" width="420"></el-table-column>
              <el-table-column prop="sortCategoryValue" label="Category" width="320"></el-table-column>
              <el-table-column prop="startDate" label="Start Date" width="360"></el-table-column>
            </el-table>
          </div>

          <!-- 右侧第三行：三个大型统计卡片 -->
          <el-row :gutter="20" style="margin: 1.5vh 0">
            <el-col :span="8">
              <div class="grid-content">
                <div class="klzt">{{ statistics.received }}</div>
                <div class="stat_ys">Received pallets</div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content">
                <div class="klzt">{{ statistics.shipped }}</div>
                <div class="stat_ys">Shipped pallets</div>
              </div>
            </el-col>
            <el-col :span="8">
              <div class="grid-content">
                <div class="klzt">{{ statistics.stock }}</div>
                <div class="stat_ys">In Stock pallets</div>
              </div>
            </el-col>
          </el-row>

          <!-- 右侧第四行：多列列表+分页 -->
          <div style="margin: 1.5vh 0; flex-grow: 1; display: flex; flex-direction: column; box-sizing: border-box;">
            <el-table :data="pallentTableData" style="width: 100%; flex-grow: 1;"
              :header-cell-style="{ background: '#FAFAFA', color: 'rgba(0, 0, 0, 0.65)' }"
              @row-click="handlePallentRowClick">
              <el-table-column prop="palletNumber" label="Pallet No" width="220"></el-table-column>
              <el-table-column prop="statusDesc" label="Pallet Status" width="120"></el-table-column>
              <el-table-column prop="receiveDate" label="Received Time" width="160" :formatter="formatTimestamp"></el-table-column>
              <el-table-column prop="shipmentDate" label="Shipped Time" width="160" :formatter="formatTimestamp"></el-table-column>
              <el-table-column prop="receivedNo" label="Received No" width="160"></el-table-column>
              <el-table-column prop="shippedNo" label="Shipped No" width="160"></el-table-column>
              <el-table-column prop="receivedTrailer" label="Received Trailer" width="160"></el-table-column>
              <el-table-column prop="receivingFrom" label="Receiving From" width="120"></el-table-column>
              <el-table-column prop="shipmentFrom" label="Shipping To" width="100"></el-table-column>
              <el-table-column prop="shippedTrailer" label="Ship Trailer" width="160"></el-table-column>

            </el-table>

            <!-- 列表分页 -->
            <div class="block" style="margin-top: 1vh">
              <el-pagination @size-change="handlePallentSizeChange" @current-change="handlePallentCurrentChange"
                :current-page.sync="pallentCurrentPage" :page-sizes="[100, 200, 300, 400]" :page-size="10"
                layout="prev, pager, next" :total="pallentTotal">
              </el-pagination>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 弹出层：el-drawer -->
    <el-drawer title="Pallet Detail" :visible.sync="drawerVisible" :direction="direction" :with-header="true">
      <div class="drawerContent">
        <el-form ref="pallentDetailForm" :model="currentPallent" label-width="120px" size="medium">
          <!-- 第一行：Pallent No + Pallent Status -->
          <el-row :gutter="20" style="margin-bottom: 1.5vh">
            <el-col :span="12">
              <el-form-item label="Pallet No">
                <el-input v-model="currentPallent.palletNumber" readonly></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="Status">
                <el-input v-model="currentPallent.statusDesc" readonly></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <!-- 第二行：Received Time + Shipped Time -->
          <el-row :gutter="20" style="margin-bottom: 1.5vh">
            <el-col :span="12">
              <el-form-item label="Received Time">
                <el-input :value="formatTimestampValue(currentPallent.receiveDate)" readonly></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="Shipped Time">
                <el-input :value="formatTimestampValue(currentPallent.shipmentDate)" readonly></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <!-- 第三行：Received No + Shipped No -->
          <el-row :gutter="20" style="margin-bottom: 1.5vh">
            <el-col :span="12">
              <el-form-item label="Received No">
                <el-input v-model="currentPallent.receivedNo" readonly></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="Shipped No">
                <el-input v-model="currentPallent.shippedNo" readonly></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <!-- 第四行：Received Trailer + Receiving From -->
          <el-row :gutter="20" style="margin-bottom: 1.5vh">
            
            <el-col :span="12">
              <el-form-item label="Receiving From">
                <el-input v-model="currentPallent.receivingFrom" readonly></el-input>
              </el-form-item>
            </el-col>

            <el-col :span="12">
              <el-form-item label="Shipping To">
                <el-input v-model="currentPallent.shipmentFrom" readonly></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <!-- 第五行：Shipping To + Shipping From -->
          <el-row :gutter="20" style="margin-bottom: 1.5vh">
            <!-- <el-col :span="12">
              <el-form-item label="Shipping To">
                <el-input v-model="currentPallent.shippingTo" readonly></el-input>
              </el-form-item>
            </el-col> -->

            <el-col :span="12">
              <el-form-item label="Received Trailer">
                <el-input v-model="currentPallent.receivedTrailer" readonly></el-input>
              </el-form-item>
            </el-col>

            
            <el-col :span="12">
              <el-form-item label="Ship Trailer">
                <el-input v-model="currentPallent.shippedTrailer" readonly></el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <!-- 第六行：Receiving Pictures 折叠面板 -->
          <el-row style="margin-bottom: 1.5vh; width: 100%">
            <el-col :span="24">
              <div style="margin-bottom: 8px; font-weight: 500; color: #333;">Receiving Pictures</div>
              <el-collapse v-model="activeCollapse" style="width: 100%">
                <el-collapse-item name="receiving">
                  <div class="demo-image__lazy"
                    style="width: 100%; display: flex; flex-wrap: wrap; gap: 1vw; padding: 1vw 0">
                    <el-image fit="cover" style="width: 120px; height: 120px"
                      v-for="(url, idx) in currentPallent.receivingPhotos" :key="idx" :src="url"
                      :preview-src-list="currentPallent.receivingPhotos"></el-image>
                  </div>
                </el-collapse-item>
              </el-collapse>
            </el-col>
          </el-row>

          <!-- 第七行：Shipping Pictures 折叠面板 -->
          <el-row style="margin-bottom: 1.5vh; width: 100%">
            <el-col :span="24">
              <div style="margin-bottom: 8px; font-weight: 500; color: #333;">Shipping Pictures</div>
              <el-collapse v-model="activeCollapse" style="width: 100%">
                <el-collapse-item name="shipping">
                  <div class="demo-image__lazy"
                    style="width: 100%; display: flex; flex-wrap: wrap; gap: 1vw; padding: 1vw 0">
                    <el-image fit="cover" style="width: 120px; height: 120px"
                      v-for="(url, idx) in currentPallent.shipmentPhotos" :key="idx" :src="url"
                      :preview-src-list="currentPallent.shipmentPhotos"></el-image>
                  </div>
                </el-collapse-item>
              </el-collapse>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </el-drawer>
  </div>
</template>

<script>
import objstorage from "@/common/localstorage/storage.js";
import objaxios from "axios";
import objurl from "@/common/interface/url.js";
export default {
  components: {},
  data() {
    return {
      // 用户信息
      objuserinfo: {},
      // 左侧Part相关
      partForm: {},
      queryParams: {
        pageNum: 1,
        pageSize: 16,
        partNumber: '',
      },
      partData: [],
      partCurrentPage: 1,
      partTotal: 0,
      selectedPart: null, // 左侧选中的Part

      // 右侧筛选参数
      filterParams: {
        pageNum: 1,
        pageSize: 10,
        palletNumber: null,
        dateRange: [new Date(), new Date()], // 默认当前日期
      },

      // 右侧第二行列表数据 - 添加额外字段用于填充宽度
      summaryTableData: [

      ],
      statistics: {

      },
      // 右侧第四行列表数据
      pallentTableData: [],
      pallentCurrentPage: 1,
      pallentTotal: 0, // 模拟数据总数

      // 抽屉相关
      drawerVisible: false,
      direction: "rtl",
      activeCollapse: ["receiving"], // 默认展开Receiving Pictures
      currentPallent: {}, // 当前选中的Pallent详情
    };
  },
  watch: {},
  methods: {
    // 通用处理函数：将逗号分隔的图片URL转为数组
    xparsePhotoUrls(photoStr) {
      if (!photoStr) return []; // 处理 null/undefined/空字符串
      // 按逗号分割，过滤空字符串（避免 ",url" 或 "url," 导致的空项）
      return photoStr.split(',').map(url => url.trim()).filter(url => url);
    },
    handlePartRowClick(row, column, event) {
      console.log(row);
      this.filterParams.pageNum = 1;
      this.filterParams.partNumber = row.code;
      this.selectedPart = row;
      this.statistics={}
      this.summaryTableData=[]
      this.pallentTableData=[]
      this.currentPallent={}
      this.drawerVisible=false
      this.$forceUpdate()
      this.sort_listByInbound();
      this.inbound_statistics()
      this.inbound_detail_page()
    },
    inbound_detail_page() {
      var _this = this;
      objaxios.defaults.headers.common["Authorization"] =
        objstorage.get("userinfo").tokenHead +
        objstorage.get("userinfo").token;
      objaxios
        .post(objurl.inbound_detail_page, this.filterParams)
        .then(function (ress) {
          if (ress.data.code == 200) {

            // 假设接口返回数据为response
            const rawList = ress.data.data.list

            // 处理每一项数据
            const processedList = rawList.map(item => {
              // 处理receivingPhoto：分割为数组，空值时返回空数组
              let receivingPhotos = [];
              if (item.receivingPhoto && typeof item.receivingPhoto === 'string') {
                // 分割后过滤空字符串（避免多余逗号导致的空项）
                receivingPhotos = item.receivingPhoto.split(',').filter(url => url.trim() !== '');
              }

              // 处理shipmentPhoto：同上
              let shipmentPhotos = [];
              if (item.shipmentPhoto && typeof item.shipmentPhoto === 'string') {
                shipmentPhotos = item.shipmentPhoto.split(',').filter(url => url.trim() !== '');
              }

              return {
                ...item,
                receivingPhotos, // 转换后的接收图片数组
                shipmentPhotos   // 转换后的发货图片数组
              };
            });

            // 将处理后的数据用于渲染
            // this.list = processedList;

            _this.pallentTableData = processedList
            console.log("_this.pallentTableData")
            console.log(_this.pallentTableData)

            _this.pallentTotal = parseInt(ress.data.data.total);
            _this.$forceUpdate();
          } else if (ress.data.code == 401) {
            _this.$message.error(ress.data.message);
            objstorage.remove("userinfo");
            _this.$router.replace("/");
          } else {
            _this.$message.error(ress.data.message);
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    inbound_statistics() {
      var _this = this;
      objaxios.defaults.headers.common["Authorization"] =
        objstorage.get("userinfo").tokenHead +
        objstorage.get("userinfo").token;
      objaxios
        .post(objurl.inbound_statistics, this.filterParams)
        .then(function (ress) {
          if (ress.data.code == 200) {
            _this.statistics = ress.data.data
            _this.$forceUpdate();
          } else if (ress.data.code == 401) {
            _this.$message.error(ress.data.message);
            objstorage.remove("userinfo");
            _this.$router.replace("/");
          } else {
            _this.$message.error(ress.data.message);
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    sort_listByInbound() {
      var _this = this;
      objaxios.defaults.headers.common["Authorization"] =
        objstorage.get("userinfo").tokenHead +
        objstorage.get("userinfo").token;
      objaxios
        .post(objurl.sort_listByInbound, {
          palletNumber: this.filterParams.palletNumber,
          partNumber: this.filterParams.partNumber,
          startDate: this.filterParams.startDate,
          endDate: this.filterParams.endDate,

        })
        .then(function (ress) {
          if (ress.data.code == 200) {
            _this.summaryTableData = ress.data.data
            _this.$forceUpdate();
          } else if (ress.data.code == 401) {
            _this.$message.error(ress.data.message);
            objstorage.remove("userinfo");
            _this.$router.replace("/");
          } else {
            _this.$message.error(ress.data.message);
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    // 左侧Part输入框事件
    partNumberInput() { },

    // 左侧Part搜索
    searchPartData() {
      this.queryParams.pageNum = 1;
      this.partCurrentPage = 1;
      this.sku_page()
    },
    sku_page() {
      var _this = this;
      objaxios.defaults.headers.common["Authorization"] =
        objstorage.get("userinfo").tokenHead + objstorage.get("userinfo").token;
      objaxios
        .post(objurl.sku_page, _this.queryParams)
        .then(function (res) {
          if (res.data.code == 200) {
            _this.partData = res.data.data.list;

            _this.partTotal = parseInt(res.data.data.total);
            if (_this.partData.length > 0) {
              _this.handlePartRowClick(_this.partData[0]);
            }
          } else if (res.data.code == 401) {
            _this.$message.error(res.data.message);
            objstorage.remove("userinfo");
            _this.$router.replace("/");
          } else {
            _this.$message.error(res.data.message);
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    // 左侧分页：每页条数变化
    handlePartSizeChange(val) {
      this.queryParams.pageSize = val;
      this.sku_page();
    },

    // 左侧分页：当前页变化
    handlePartCurrentChange(val) {
      console.log(val)
      this.queryParams.pageNum = val;
      this.partCurrentPage = val;
      this.sku_page();
    },

    // 右侧Report按钮点击
    handleReportClick() {
      var _this = this;
      objaxios.defaults.headers.common["Authorization"] =
        objstorage.get("userinfo").tokenHead + objstorage.get("userinfo").token;
      objaxios({
        method: "post",
        url: objurl.inbound_export,
        data: this.filterParams,
        responseType: "blob",
      })
        .then((response) => {
          // _this.download(response)
          if (!response) return;
          const blob = new Blob([response.data], {
            type: "application/vnd.ms-excel",
          }); // 构造一个blob对象来处理数据，并设置文件类型
          if (window.navigator.msSaveOrOpenBlob) {
            //兼容IE10
            navigator.msSaveBlob(blob, this.filename);
          } else {
            const href = URL.createObjectURL(blob); //创建新的URL表示指定的blob对象
            const contentDisposition = response.headers["content-disposition"]; // 从response的headers中获取filename, 后端response.setHeader("Content-disposition", "attachment; filename=xxxx.docx") 设置的文件名;
            console.log("contentDisposition");
            console.log(contentDisposition);
            const patt = new RegExp("filename=([^;]+\\.[^\\.;]+);*");
            console.log(patt);
            const result = patt.exec(contentDisposition);
            console.log(result);
            // const filename = decodeURI(escape(result[1])) // 处理文件名,解决中文乱码问题
            let filename = result[1].toString(); // 处理文件名,解决中文乱码问题
          //  filename = filename.substr(1);
            filename = filename.substr(0, filename.length - 1);

            // const filename ="aaaaa.xlsx"
            console.log(filename);
            let objectUrl = window.URL.createObjectURL(
              new Blob([response.data])
            );
            const elink = document.createElement("a");
            console.log(elink);
            elink.download = filename; //下载文件名称,
            elink.style.display = "none";
            elink.href = objectUrl;
            document.body.appendChild(elink);
            elink.click();
            document.body.removeChild(elink);
            window.URL.revokeObjectURL(elink.href); // 释放URL 对象
          }
        })
        .catch((error) => { });
    },

    // 右侧搜索按钮
    handleRightSearch() {
      this.sort_listByInbound();
      this.inbound_statistics()
      this.inbound_detail_page()
      // this.$message.success("搜索成功");
      // 实际项目中此处触发接口请求，更新pallentTableData
    },

    // 右侧清空按钮
    handleRightClear() {
      this.filterParams.pageNum = 1
      this.filterParams.palletNumber = null;
      this.pallentCurrentPage = 1
      // this.filterParams.dateRange = [new Date(), new Date()];
      this._initSortDataTime()
      this.handleRightSearch()
      // this.$message.success("筛选条件已清空");
    },

    // 右侧第四行列表行点击（打开抽屉）
    handlePallentRowClick(row) {
      this.currentPallent = { ...row };
      this.drawerVisible = true;
    },

    // 右侧第四行列表分页：每页条数变化
    handlePallentSizeChange(val) {
      // 实际项目中更新pageSize并请求数据
      this.$message.info(`每页显示 ${val} 条`);
    },

    // 右侧第四行列表分页：当前页变化
    handlePallentCurrentChange(val) {
      this.filterParams.pageNum = val
      this.inbound_detail_page()

      // 实际项目中更新pageNum并请求数据
    },

    // 退出系统
    outSys() {
      var _this = this;
      objaxios.defaults.headers.common["Authorization"] =
        objstorage.get("userinfo").tokenHead + objstorage.get("userinfo").token;
      objaxios
        .post(objurl.user_logout)
        .then(function (res) {
          if (res.data.code == 200) {
            objstorage.remove("userinfo");
            _this.$router.replace("/");
          } else if (res.data.code == 401) {
            _this.$message.error(res.data.message);
            objstorage.remove("userinfo");
            _this.$router.replace("/");
          } else {
            _this.$message.error(res.data.message);
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    // 初始化数据
    _initData() {
      this.objuserinfo = objstorage.get("userinfo"); // 模拟默认用户
      this.searchPartData(); // 初始化加载左侧Part列表
      this._initSortDataTime();
    },

    _initSortDataTime() {
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
      this.filterParams.dateRange = [start, end];
      console.log(this.filterParams.dateRange)
      this.filterParams.startDate = this.formatDateToday(
        this.filterParams.dateRange[0]
      );
      this.filterParams.endDate = this.formatDateToday(
        this.filterParams.dateRange[1]
      );
    },

    formatDateToday(myDate) {
      return myDate.getTime();

      //获取当前时间并打印
      // let wk = myDate.getDay();
      // let yy = String(myDate.getFullYear());
      // let mm = String(
      //   myDate.getMonth() + 1 < 10
      //     ? "0" + (myDate.getMonth() + 1)
      //     : myDate.getMonth() + 1
      // );
      // let dd = String(
      //   myDate.getDate() < 10 ? "0" + myDate.getDate() : myDate.getDate()
      // );
      // let hou = String(
      //   myDate.getHours() < 10 ? "0" + myDate.getHours() : myDate.getHours()
      // );
      // let min = String(
      //   myDate.getMinutes() < 10
      //     ? "0" + myDate.getMinutes()
      //     : myDate.getMinutes()
      // );
      // let sec = String(
      //   myDate.getSeconds() < 10
      //     ? "0" + myDate.getSeconds()
      //     : myDate.getSeconds()
      // );
      // let weeks = [
      //   "星期日",
      //   "星期一",
      //   "星期二",
      //   "星期三",
      //   "星期四",
      //   "星期五",
      //   "星期六",
      // ];
      // let week = weeks[wk];
      // // this.objdatenow = yy + ' 年 ' + mm + ' 月 ' + dd + ' 日'
      // // this.objdatenow = hou + ' : ' + min + ' : ' + sec
      // // this.nowWeek = week
      // var time = yy + "-" + mm + "-" + dd;
      // return time;
    },

    // 格式化时间戳（用于表格列的formatter）
    formatTimestamp(row, column, cellValue) {
      if (!cellValue) return '';
      const timestamp = typeof cellValue === 'string' ? parseInt(cellValue) : cellValue;
      if (isNaN(timestamp)) return cellValue;
      const date = new Date(timestamp);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },

    // 格式化时间戳值（用于直接显示）
    formatTimestampValue(timestamp) {
      if (!timestamp) return '';
      const ts = typeof timestamp === 'string' ? parseInt(timestamp) : timestamp;
      if (isNaN(ts)) return timestamp;
      const date = new Date(ts);
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      const hours = String(date.getHours()).padStart(2, '0');
      const minutes = String(date.getMinutes()).padStart(2, '0');
      const seconds = String(date.getSeconds()).padStart(2, '0');
      return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
    },
  },
  created() {
    this._initData();
  },
  mounted() {
    // 模拟页面刷新逻辑（保持原参考代码逻辑）
    if (location.href.indexOf("#reloaded") === -1) {
      location.href = location.href + "#reloaded";
      location.reload();
    }
  },
};
</script>

<style lang='stylus' rel='stylesheet/stylus'>
// 复用原参考代码样式，仅调整差异部分
.homePage {
  height: 100vh;
  width: 100%;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  .customer-table th {
    border: none;
  }

  .el-table {
    overflow: scroll;
  }

  // 去除表格各种边框
  .customer-table td, .customer-table th.is-leaf {
    border: none;
  }

  // 表格最外边框
  .el-table--border, .el-table--group {
    border: none;
  }

  // 头部边框
  .customer-table thead tr th.is-leaf {
    border: 1px solid #EBEEF5;
    border-right: none;
  }

  .customer-table thead tr th:nth-last-of-type(2) {
    border-right: 1px solid #EBEEF5;
  }

  // 表格最外层边框-底部边框
  .el-table--border::after, .el-table--group::after {
    width: 0;
  }

  .customer-table::before {
    width: 0;
  }

  .customer-table .el-table__fixed-right::before, .el-table__fixed::before {
    width: 0;
  }

  // 表格有滚动时表格头边框
  .el-table--border th.gutter:last-of-type {
    border: 1px solid #EBEEF5;
    border-left: none;
  }

  // 去除边框线
  /deep/ .el-table::before {
    height: 0;
  }

  /deep/ .el-table__body-wrapper::-webkit-scrollbar-thumb {
    background-color: #2751be;
    border-radius: 6px;
  }

  /deep/ .el-table__body-wrapper::-webkit-scrollbar {
    width: 8px; // 横向滚动条
    height: 25px; // 纵向滚动条 必写
    background: #12244d;
  }

  /deep/ .el-table__body-wrapper::-webkit-scrollbar-track {
    border-radius: 10px; /* 滚动条的背景区域的圆角 */
    background-color: rgb(18, 36, 77); /* 滚动条的背景颜色 */
  }

  // 顶部Header样式（完全复用）
  .Header {
    height: 8vh;
    min-height: 77px;
    padding: 0 2vw;
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: #fff;
    background: rgb(11, 26, 40);

    .h_left {
      display: flex;
      align-items: center;
    }

    .h_right {
      white-space: nowrap;
      display: flex;
      align-items: center;

      img {
        width: 1.5vw;
        height: 1.5vw;
      }

      .htex {
        margin: 0 1.5vw;
        font-size: 12px;
      }
    }

    .collpase {
      margin-right: 1vw;
    }
  }

  // 主体内容区样式 - 调整高度使其更接近底部
  .home-page-body {
    height: calc(100vh - 8vh);
    padding: 2vh 3vh;
    overflow: hidden;

    .btys {
      display: flex;
      align-items: center;
      height: 6vh;
      font-size: 24px;
      font-weight: 800;
      color: rgb(39, 60, 94);
      margin-bottom: 1vh;
    }

    // 左侧区域样式（保持圆角边框，增加列表高度）
    .leftmenu {
      position: relative;
      height: 100%;
      width: 14vw;
      color: #fff;
      border: 1px solid #e8e8e8;
      border-radius: 10px;
      min-width: 200px !important;
      padding: 1vh 1vw 40px;
      display: flex;
      flex-direction: column;

      .el-table__body tr:hover>td {
        background-color: rgb(39, 60, 94) !important;
        color: #fff;
        font-weight: 800;
      }

      .fyys {
      position: absolute;
  bottom: 1vh;
  left: 50%;
  transform: translateX(-50%);
  width: 90%;
  display: flex;
  justify-content: center;
      }
    }

    // 右侧区域样式 - 增加整体高度
    .rightmenu {
      display: flex;
      flex-direction: column;
      padding: 1.5vh 2vh;
      flex: 1;
      overflow-y: auto;
      border: 1px solid #e8e8e8;
      border-left: none;
      border-radius: 10px;
      height: 100%;
      box-sizing: border-box;

      // 右侧第一行样式
      .r_tbys {
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-wrap: wrap;
        gap: 1vh;
        margin-bottom: 1vh;

        .r_lys {
          display: flex;
          align-items: center;
        }

        .ztyss {
          font-size: 24px;
          font-weight: 800;
          color: rgb(39, 60, 94);
        }

        .delys {
          display: flex;
          justify-content: center;
          align-items: center;
          width: 60px;
          height: 30px;
          border-radius: 6px;
          background: rgb(39, 60, 94);
          color: #ffffff;
          font-size: 12px;
        }

        .r_rys {
          display: flex;
          align-items: center;
          flex-wrap: wrap;
        }

        .bdys {
          font-size: 14px;
          color: rgba(0, 0, 0, 0.65);
        }
      }

      // 统计卡片样式 - 减小高度
      .grid-content {
        border-radius: 10px;
        //border: 1px solid #e8e8e8;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 1vw;
        height: 80px;

        .klzt {
          font-size: 24px;
          font-weight: 800;
          color: rgb(39, 60, 94);
          margin-bottom: 0.5vh;
        }

        .stat_ys {
          font-size: 14px;
          color: rgba(0, 0, 0, 0.7);
        }
      }

      // 分页位置
      .block {
        margin-top: 1vh;
        display: flex;
        justify-content: end;
      }
    }
  }

  // 抽屉样式
  .el-drawer, .rtl {
    min-width: 600px;
    width: 50% !important;
  }

  .drawerContent {
    padding: 2vw;
  }

  // 折叠面板样式调整
  /deep/ .el-collapse-item__header {
    padding-left: 0 !important;
    font-weight: 500;
  }

  // 折叠面板图片区域
  .demo-image__lazy {
    margin-top: 1vw;
  }

  // 表单行间距
  .el-row {
    margin-bottom: 1vw;
  }
}
</style>


// WEBPACK FOOTER //
// src/views/index.vue